(() => {
  if (customElements.get('lc-collection-video')) return;
  customElements.define('lc-collection-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.label = this.querySelector('[data-lc-video-label]');
      if (!this.video || !this.button) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.mobile = matchMedia('(max-width: 749px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.userPaused = false;
      this.loaded = false;
      this.video.muted = true;
      const sync = () => this.sync();
      this.mobile.addEventListener('change', sync, options);
      this.motion.addEventListener('change', sync, options);
      document.addEventListener('visibilitychange', sync, options);
      this.video.addEventListener('playing', () => {
        this.setAttribute('data-playing', '');
        this.label.textContent = 'Pauză video';
        this.button.setAttribute('aria-label', 'Pune videoclipul pe pauză');
      }, options);
      this.video.addEventListener('pause', () => {
        this.label.textContent = 'Redă video';
        this.button.setAttribute('aria-label', 'Redă videoclipul');
      }, options);
      this.video.addEventListener('error', () => {
        this.removeAttribute('data-playing');
        this.button.hidden = true;
      }, options);
      this.button.addEventListener('click', () => {
        if (this.video.paused) {
          this.userPaused = false;
          this.play();
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      });
      this.observer.observe(this);
      this.sync();
    }
    allowed() { return !(this.dataset.mobile === 'false' && this.mobile.matches); }
    play() {
      if (!this.allowed()) return;
      if (!this.loaded) {
        this.querySelectorAll('source[data-src]').forEach(source => {
          source.src = source.dataset.src;
        });
        this.loaded = true;
        this.video.load();
      }
      const attempt = this.video.play();
      if (attempt) attempt.catch(() => { /* Poster stays visible; button allows manual play. */ });
    }
    sync() {
      this.button.hidden = !this.allowed();
      if (!this.allowed() || !this.visible || document.hidden || this.motion.matches || this.userPaused) {
        this.video.pause();
        if (!this.allowed() || this.motion.matches) this.removeAttribute('data-playing');
        return;
      }
      this.play();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.video?.pause();
    }
  });
})();
